import React from "react";

const variantStyles = {
  default: "border border-bookish-purple/10 rounded-2xl shadow-sm",
  elevated: "border border-bookish-purple/10 rounded-2xl shadow-[0_12px_40px_rgba(63,37,107,0.10)]",
};

const Card = ({ title, value, note, variant = "default", children, className = "" }) => {
  const base = `bg-white p-4 sm:p-6 ${variantStyles[variant] || variantStyles.default}`;

  if (title || value || note) {
    return (
      <div className={`${base} ${className}`}>
        {title && <h3 className="text-lg font-bold text-bookish-purple mb-2">{title}</h3>}
        {value && <p className="text-2xl font-bold text-bookish-purple">{value}</p>}
        {note && <p className="text-sm text-green-600">{note}</p>}
        {children}
      </div>
    );
  }

  return (
    <div className={`${base} ${className}`}>
      {children}
    </div>
  );
};

export default Card;
